import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

const SpecificationsPropCompliance = (props) => {
  const { product, getPropCompliance } = props || {};

  // Request proposition 65 compliance message
  const [prop65] = getPropCompliance?.(
    product?.manufacturer?.id,
    product?.category?.code
  );

  const renderMessage = () => {
    // Generate a sanitized compliance message
    const sanitizedData = () => ({
      __html: DOMPurify.sanitize(prop65),
    });
    return <div dangerouslySetInnerHTML={sanitizedData()} />
  };

  if (!prop65) return null;
  return (
    <section
      className="c-product-specifications__prop-compliance pcmWarning"
      data-testid="pcmWarning"
    >
      <i className="ion-android-warning c-icon--warning c-compliance-icon" />
      {renderMessage()}
    </section>
  );
};

export default SpecificationsPropCompliance;

SpecificationsPropCompliance.propTypes = {
  product: PropTypes.object,
  // getPropCompliance - is a custom hook
  // returns: [data, loading, error]
  getPropCompliance: PropTypes.func.isRequired,
};

SpecificationsPropCompliance.defaultProps = {
  product: {},
  getPropCompliance: () => [],
};
